import { createFileRoute } from '@tanstack/react-router';
import { ProviderConfigSettings } from '@/components/companies/provider-config-settings';

const WEB_SEARCH_SLOTS = [{ slot: 'web_search', label: 'Web search' }];

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/web-browsing/configuration',
)({
  component: () => (
    <ProviderConfigSettings
      header={false}
      slots={WEB_SEARCH_SLOTS}
      title="Web Search Providers"
      description="Order the web-search waterfall: earlier providers run first; a no-match (or error) falls through to the next. Leave Org blank for the global default."
    />
  ),
});
